import AppWrapper from "./AppWrapper";
import { Provider } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import globalRouter from "./core/globalRouter";
import { store } from "./redux/store";
import ErrorPage from "./components/errorBoundary/ErrorPage";
import ThemeConfig from "./theme";
import CssBaseline from '@mui/material/CssBaseline';

const CSSThemeProvider = () => {
  return (
    <ThemeConfig>
      <>
        <CssBaseline />
        <AppWrapper />
      </>
    </ThemeConfig>
  );
};

const App = () => {
  const navigate = useNavigate();
  globalRouter.navigate = navigate;

  return (
    <Provider store={store}>
      <ErrorBoundary fallback={<ErrorPage />}>
        <CSSThemeProvider />
      </ErrorBoundary>
    </Provider>
  );
};

export default App;
